import { createContext } from 'react'

/** Section-режим («один поповер инструментов», Artlist-style): внутри
 *  провайдера `BbarSectionMode` пилюля BottomBarPopover рендерится НЕ
 *  пилюлей-с-поповером, а плоской секцией общей панели (заголовок + чипы /
 *  тумблер / слайдер). Логика (value/onChange/active/onToggle/slider) — та
 *  же, ноль изменений: меняется только презентация. Так ВСЕ инструменты
 *  SettingsPillsRow автоматически попадают в общий поповер без правок его
 *  матрицы. Отдельный файл — требование react-refresh (только компоненты
 *  в компонент-файлах). */
export const BbarSectionMode = createContext(false)
